"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateURLParams = exports.isReferrerFromNoom = exports.extractFromExternalParams = exports.extractUtmSource = exports.NOOM_DOMAINS_MATCH = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
exports.NOOM_DOMAINS_MATCH = [
    "^http://localhost:8080",
    "^https://.*.noom.com",
    "^https://buyflow-lambda.(dev|test).wsli.dev",
    "^https://buyflow-web-assets.test.wsli.dev",
]
    .map((domain) => `(${domain})`)
    .reduce((val, acc) => `${acc}|${val}`);
const REFERRER_TO_UTM_SOURCE_MAPPING = {
    none: "$direct",
    ".*google\\..*": "google_organic",
    ".*facebook\\..*": "facebook_organic",
    ".*instagram\\..*": "instagram_organic",
    ".*pinterest\\..*": "pinterest_organic",
    ".*bing\\..*": "bing_organic",
    ".*twitter\\..*": "twitter_organic",
    ".*noom\\..*": "noom_internal",
};
function extractUtmSource(searchParams, referrer, priorTrackingParameters) {
    const utmSourceFromURL = searchParams.get("utm_source");
    if (utmSourceFromURL) {
        return utmSourceFromURL;
    }
    if (priorTrackingParameters === null || priorTrackingParameters === void 0 ? void 0 : priorTrackingParameters.utm_source) {
        return priorTrackingParameters.utm_source;
    }
    if (referrer) {
        return (REFERRER_TO_UTM_SOURCE_MAPPING[Object.keys(REFERRER_TO_UTM_SOURCE_MAPPING).find((key) => referrer.match(key))] || "other");
    }
    return "$direct";
}
exports.extractUtmSource = extractUtmSource;
function extractFromExternalParams(sessionCookieDomain, externalUrlParamKey) {
    const externalUrlParams = JSON.parse(decodeURIComponent(js_cookie_1.default.get(externalUrlParamKey) || ""));
    js_cookie_1.default.remove(externalUrlParamKey, {
        path: "/",
        domain: sessionCookieDomain,
    });
    return [externalUrlParams.url, externalUrlParams.referrer];
}
exports.extractFromExternalParams = extractFromExternalParams;
function isReferrerFromNoom(referrer = document.referrer) {
    return !!(referrer === null || referrer === void 0 ? void 0 : referrer.match(exports.NOOM_DOMAINS_MATCH));
}
exports.isReferrerFromNoom = isReferrerFromNoom;
function updateURLParams(newParams) {
    const url = new URL(location.href);
    Object.entries(newParams).forEach(([key, value]) => {
        if (value == null) {
            url.searchParams.delete(key);
        }
        else {
            url.searchParams.set(key, `${value}`);
        }
    });
    history.replaceState(history.state, "", url.toString());
}
exports.updateURLParams = updateURLParams;
//# sourceMappingURL=url.js.map